(function() {
  // Track dismissed notices in sessionStorage so they stay dismissed during this session
  // but reappear in a new session (next visit)
  
  function getDismissed() {
    try {
      return JSON.parse(sessionStorage.getItem('dismissedCartNotices') || '[]');
    } catch (e) {
      return [];
    }
  }

  function setDismissed(list) {
    try {
      sessionStorage.setItem('dismissedCartNotices', JSON.stringify(list));
    } catch (e) {}
  }

  function applyDismissed() {
    const dismissed = getDismissed();
    document.querySelectorAll('[data-dismissible-notice]').forEach(notice => {
      const type = notice.getAttribute('data-dismissible-notice');
      if (dismissed.includes(type)) {
        notice.style.display = 'none';
      }
    });
  }

  function attachHandlers() {
    document.querySelectorAll('[data-dismiss-notice]').forEach(button => {
      if (button.dataset.handlerAttached) return;
      button.dataset.handlerAttached = 'true';
      button.addEventListener('click', () => {
        const notice = button.closest('[data-dismissible-notice]');
        if (!notice) return;
        const type = notice.getAttribute('data-dismissible-notice');
        const dismissed = getDismissed();
        if (!dismissed.includes(type)) {
          dismissed.push(type);
          setDismissed(dismissed);
        }
        notice.style.display = 'none';
      });
    });
  }

  function init() {
    applyDismissed();
    attachHandlers();
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after Shopify Section Rendering API updates the cart
  // (when quantities change and cart re-renders)
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart:refresh', init);

  // Catch-all: observe DOM mutations on cart containers
  const observer = new MutationObserver(() => {
    init();
  });
  document.querySelectorAll('cart-items, cart-drawer').forEach(el => {
    observer.observe(el, { childList: true, subtree: true });
  });
})();